import { defaultField, defaultPercentField } from "helpers/row-logic-helper";

export const propertyAllocationMapNested = loan => {
  const items = defaultField(loan, "properties");

  return items.reduce((accum, property) => {
    if (!property) {
      return accum;
    }

    const allocated = defaultPercentField(property, "allocationPercent", 1);

    accum.push({
      name: defaultField(property, "property.name"),
      allocated: allocated ? `${allocated}% allocated` : undefined
    });

    return accum;
  }, []);
};
